var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.$attrs.serial,class:_vm.$attrs.gaugeClass,style:('width:'+_vm.$attrs.svgwidth+'px;height:'+_vm.$attrs.svgheight+'px;' + _vm.$attrs.svgStyle),attrs:{"width":_vm.$attrs.svgwidth,"height":_vm.$attrs.svgwidth,"id":_vm.$attrs.serial,"value":_vm.$attrs.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }